<template>
  <el-row tag="section" id="config">
    <el-col :span="18" :offset="3">
      <el-table
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width: 100%">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          property="baseId"
          label="Base ID"
          width="200">
        </el-table-column>
        <el-table-column
          property="name"
          label="Name"
          width="200">
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope" v-if="scope.row.default === 'Default'">
            <el-tag
              :type="'primary'"
              disable-transitions>{{scope.row.default}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="🎮"
          width="80">
          <template slot-scope="scope">
            <el-button @click="openGame(scope.row.baseId)" type="text" size="small">Play</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px" v-if="selected">
        <el-button @click="setCurrent()">Clear selection</el-button>
        <el-button @click="setDefault()" :type="'primary'">Make default</el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>

  import axios from 'axios'

  export default {
    name: 'config',
    data() {
      return {
        tableData: [{}],
        currentRow: null,
        selected: false
      }
    },
    created() {
      this.fetchTables()
    },
    methods: {
      setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
      },
      handleCurrentChange(val) {
        this.selected = val ? true : false;
        this.currentRow = val;
      },
      setDefault() {
        let vm = this
        axios.post('api/tables', null, {params: {id: this.currentRow.recordId}})
          .then(function (response) {
            vm.tableData = response.data
          })
      },
      fetchTables() {
        let vm = this
        axios.get('/api/tables')
          .then(function (response) {
            return vm.tableData = response.data
          })
          .catch(function (error) {
            // add retry
            // vm.industries = ['Error! Could not reach the API. ' + error]
          })
          .finally(function() {
            // loader.close()
            // vm.$root.$emit('loadWhatif', vm.whatIfs)
          })
      },
      openGame(id) {
        window.open('/?id=' + id)
      }
    }
  }
</script>